module.exports = __webpack_public_path__ + "static/media/screenshot-5.7735360d.png";